import*as o from"react";import{vars as t}from"./theme.css";import{fontGroups as s}from"./font-groups.css";import"./reset.css";var f={S:{100:320,200:550},M:{100:768},L:{100:1024}};export{s as fontGroups,f as queries,t as vars};
